import type { FC, ReactNode, RefObject } from 'react';

import type { MetadataField } from '@/model/Metadata.model';
import type { CompatibleCellChange, CompatibleChangeSource } from '@/components/UI/SpreadSheet/Spreadsheet';

import Spreadsheet, { type SpreadsheetSettings } from '@/components/UI/SpreadSheet/Spreadsheet';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTable';
import { defaultMetadataToColumnSettingMapper } from '@/support/hot';

interface CreateAnimalsTableProps {
  data: Array<Record<string, unknown>>;
  settings: SpreadsheetSettings;
  innerRef: RefObject<HotTableRef>;
  metadata: Array<MetadataField>;
  setMetadata: (metadata: Array<MetadataField>) => void;
  patchMetadataAfterSettingsUpdated: () => void;
  maxRows: number;
  addCol?: boolean;
  afterChange?: (changes: Array<CompatibleCellChange> | null, source: CompatibleChangeSource) => void;
  afterValidation?: (
    isValid: boolean,
    value: ReactNode,
    row: number,
    prop: string | number,
    source: CompatibleChangeSource
  ) => void;
  buttonClasses?: string;
}

const CreateAnimalsTable: FC<CreateAnimalsTableProps> = ({
  data,
  settings,
  innerRef,
  metadata,
  setMetadata,
  patchMetadataAfterSettingsUpdated,
  maxRows,
  addCol = true,
  afterChange,
  afterValidation,
  buttonClasses,
}) => {
  return (
    <Spreadsheet
      className="createAnimals"
      testPrefix="create-animals"
      data={data}
      innerRef={innerRef}
      settings={settings}
      metadata={metadata}
      setMetadata={setMetadata}
      metadataToColumnSettingMapper={defaultMetadataToColumnSettingMapper}
      patchMetadataAfterSettingsUpdated={patchMetadataAfterSettingsUpdated}
      maxRows={maxRows}
      addCol={addCol}
      afterChange={afterChange}
      afterValidation={afterValidation}
      buttonClasses={buttonClasses}
    />
  );
};

export default CreateAnimalsTable;
